import { processingSessionIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const abandonProcessingSession = {
  name: "abandonProcessingSession" as const,
  input: z.object({ sessionId: processingSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
